import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'

import FooterMenu from './menu/footermenu';
import BottomMenu from './menu/bottommenu';
import Socialmedia from './socialmedia';
import Chat from './chat'

import parse from 'html-react-parser'
import OpenKlaviyoFormButton from './OpenKlaviyoFormButton';

function Footer({ menu, config }) {

    const [footericons, set_icons] = useState(false);
    const [cookies_popup, set_cookies_popup] = useState(false);
    const [cookies_functional, set_cookies_functional] = useState(false);
    const [cookies_analytics, set_cookies_analytics] = useState(false);
    const [cookies_advertise, set_cookies_advertise] = useState(false);
    const [cookies_necessary, set_cookies_necessary] = useState("Always Active");
    const [cookies_custom_view, set_cookies_custom_view] = useState(false);

    const [show_content_functional,set_show_content_functional] = useState(false);
    const [show_secessary, set_show_secessary] = useState(false);
    const [show_content_analytics,set_show_content_analytics] = useState(false);
    const [show_content_advertise, set_show_content_advertise] = useState(false);

    const user_cookies = {
        "_AW_ACCEPTED_ALL": "NO",
        "_AW_REJECTED_ALL": "NO",
        "_AW_NECESSARY": "NO",
        "_AW_FUNCTIONAL": "NO",
        "_AW_ANALYTICS": "NO",
        "_AW_ADVERTISE": "NO",
        "_AW_EXIST": "NO"
    };

    const get_footer_menu = (menu) => {
        // function to take all the menus and only extract the header one for rendering here
        if (menu) {
            var result = menu.filter(obj => {
                return obj.slug == 'footer'
            })
            return result[0]
        }
    }
    const get_bottom_menu = (menu) => {
        // function to take all the menus and only extract the header one for rendering here
        if (menu) {
            var result = menu.filter(obj => {
                return obj.slug == 'bottom'
            })
            return result[0]
        }
    }


  useEffect(() => {


    const get_footer_icons = async () => {

      const res = await fetch(
        process.env.NEXT_PUBLIC_API_URL + '/landingpage/footer-icons',
        {
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'GET'
        }
      )
      .then(response => {
        // reject not ok response
        if (!response.ok) {
            return Promise.reject(response)
        }
        return response.json()
        })
        .catch(async response => {
            const error = await response.json().then(text => text)
            return Promise.reject(error)
        })
        .then(data => {
            set_icons(data.data)
        })
        .catch((error) => {
            console.log(error)
        });

    }

    get_footer_icons()

  },[]);

  const cookies_accept_all = () => {
    setCookies('ACCEPT');
    showAWCookies();
    set_cookies_popup(false);
  }

  const cookies_reject_all = () => {
    setCookies('REJECT');
    showAWCookies();
    set_cookies_popup(false);
  }

  const cookies_custom = () => {
    setCookies('CUSTOM');
    showAWCookies();
    set_cookies_popup(false);
  }

  const cookies_custom_active = () => {
    set_cookies_custom_view(!cookies_custom_view);
  }

  const setCookies = (type) => {
    if(type == 'ACCEPT') {
        setCookieValue('_AW_ACCEPTED_ALL', 'YES');
        setCookieValue('_AW_REJECTED_ALL', 'NO');
        setCookieValue('_AW_NECESSARY', 'YES');
        setCookieValue('_AW_FUNCTIONAL', 'YES');
        setCookieValue('_AW_ANALYTICS', 'YES');
        setCookieValue('_AW_ADVERTISE', 'YES');
    }
    else if(type == 'REJECT') {
        setCookieValue('_AW_ACCEPTED_ALL', 'NO');
        setCookieValue('_AW_REJECTED_ALL', 'YES');
        setCookieValue('_AW_NECESSARY', 'YES');
        setCookieValue('_AW_FUNCTIONAL', 'NO');
        setCookieValue('_AW_ANALYTICS', 'NO');
        setCookieValue('_AW_ADVERTISE', 'NO');
    }
    else if(type == 'CUSTOM') {
        var functional = cookies_functional ? 'YES' : 'NO';
        var analytics = cookies_analytics ? 'YES' : 'NO';
        var advertise = cookies_advertise ? 'YES' : 'NO';
        setCookieValue('_AW_NECESSARY', 'YES');
        setCookieValue('_AW_REJECTED_ALL', 'NO');
        if(functional == 'YES') {
            setCookieValue('_AW_FUNCTIONAL', 'YES');
        }
        else {
            setCookieValue('_AW_FUNCTIONAL', 'NO');
        }
        if(analytics == 'YES') {
            setCookieValue('_AW_ANALYTICS', 'YES');
        }
        else {
            setCookieValue('_AW_ANALYTICS', 'NO');
        }
        if(advertise == 'YES') {
            setCookieValue('_AW_ADVERTISE', 'YES');
        }
        else {
            setCookieValue('_AW_ADVERTISE', 'NO');
        }
        if(functional == 'YES' && analytics == 'YES' && advertise == 'YES') {
            setCookieValue('_AW_ACCEPTED_ALL', 'YES');
        }
        else {
            setCookieValue('_AW_ACCEPTED_ALL', 'NO');
        }
    }
}

const setCookieValue = (name, value) => {
//   console.log(name + " <===> " + value);
    var cookieName = name;
    var cookieValue = value;
    var myDate = new Date();
    myDate.setMonth(myDate.getMonth() + 2);
    document.cookie = cookieName +"=" + cookieValue + ";expires=" + myDate + ";path=/;";
}

const getAWCookies = () => { 
    var i, x, y, cookies = document.cookie.split(";");
    for (i = 0; i < cookies.length; i++) {
        x = cookies[i].substr(0, cookies[i].indexOf("="));
        y = cookies[i].substr(cookies[i].indexOf("=") + 1);
        x = x.trim();
        y = y.trim();
        if (x === "_AW_ACCEPTED_ALL") {
            user_cookies._AW_ACCEPTED_ALL = y;
            user_cookies._AW_EXIST = "YES";
        }
        else if(x === "_AW_REJECTED_ALL") {
            user_cookies._AW_REJECTED_ALL = y;
            user_cookies._AW_EXIST = "YES";
        }
        else if(x === "_AW_NECESSARY") {
            user_cookies._AW_NECESSARY = y;
            user_cookies._AW_EXIST = "YES";
        }
        else if(x === "_AW_FUNCTIONAL") {
            user_cookies._AW_FUNCTIONAL = y;
            user_cookies._AW_EXIST = "YES";
        }
        else if(x === "_AW_ANALYTICS") {
            user_cookies._AW_ANALYTICS = y;
            user_cookies._AW_EXIST = "YES";
        }
        else if(x === "_AW_ADVERTISE") {
            user_cookies._AW_ADVERTISE = y;
            user_cookies._AW_EXIST = "YES";
        }
    }
    return user_cookies;
}

  const showAWCookies = () => {
    // The cookie prompt is not shown inside the iOS app - App Review rejected the app under
    // guideline 5.1.2 for prompting about tracking cookies without an ATT permission request
    // (window.awIsApp is set in pages/_document.js)
    if (typeof window !== 'undefined' && window.awIsApp) {
        set_cookies_popup(false);
        return;
    }

    var cookies = getAWCookies();
    if(cookies._AW_EXIST == "YES") {
        set_cookies_popup(false);
    }
    else {
        set_cookies_popup(true);
        if(cookies._AW_ACCEPTED_ALL == 'YES') {
            set_cookies_functional(true);
            set_cookies_analytics(true);
            set_cookies_advertise(true);
        }
        else if(cookies._AW_REJECTED_ALL == 'YES') {
            set_cookies_functional(false);
            set_cookies_analytics(false);
            set_cookies_advertise(false);
        }
        else { 
            if(cookies._AW_NECESSARY == 'YES') {
                set_cookies_necessary('Always Active');
            }
            else {
                set_cookies_necessary('Not Active');
            }

            if(cookies._AW_FUNCTIONAL == 'YES') {
                set_cookies_functional(true);
            }
            else {
                set_cookies_functional(false);
            }

            if(cookies._AW_ANALYTICS == 'YES') {
                set_cookies_analytics(true);
            }
            else {
                set_cookies_analytics(false);
            }

            if(cookies._AW_ADVERTISE == 'YES') {
                set_cookies_advertise(true);
            }
            else {
                set_cookies_advertise(false);
            }
        }
    }
}

  useEffect(() => {
    showAWCookies();
  },[]);

    return (
        <>
            <section className="bg-brand-tertiary py-8">
                <div className="container mx-auto">
                    <div className="lg:flex justify-between items-center mx-auto lg:w-10/12 px-5 lg:px-0">
                        <div className="lg:w-6/12">
                            <h2 className="text-white font-semibold text-xl lg:text-2xl">Subscribe to our newsletter</h2>
                            <p className="text-white mb-4 lg:mb-0 text-base">Get all the latest news, articles and resources, sent to your inbox every month.</p>
                        </div>
                        <div className="lg:w-5/12">
                            <div id="mc_embed_signup">
                            {/* <div className="klaviyo-form-Yd2Swd"></div> */}
                            <OpenKlaviyoFormButton formId="UYreg6">
                            Join Our Newsletter
                            </OpenKlaviyoFormButton>
                            {/* <form
                                action={config.mailchimp_form_url}
                                method="post"
                                id="mc-embedded-subscribe-form"
                                name="mc-embedded-subscribe-form"
                                className="validate flex"
                                target="_blank"
                                noValidate>
                                <input
                                    id="mce-EMAIL"
                                    type="email"
                                    name="EMAIL"
                                    placeholder="Enter your email.."
                                    className="p-4 flex-grow min-w-0 rounded-none leading-none rounded-bl rounded-tl" />
                                <input
                                    className="bg-brand-primary text-white rounded-br rounded-tr flex items-center leading-none py-4 px-3 md:px-6 font-semibold transition duration-150 ease-in-out hover:cursor-pointer hover:bg-brand-secondary active:bg-brand-tertiary"
                                    type="submit"
                                    value="Subscribe"
                                    name="subscribe"
                                    id="mc-embedded-subscribe" />
                                
                                    <input type="text" name="b_5f3b88dde7e47efea0283b5a9_41f01ea920" className="hidden"/>
                                
                            </form> */}

                                <div id="mce-responses" className="clear">
                                    <div className="response hidden" id="mce-error-response"></div>
                                    <div className="response hidden" id="mce-success-response"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer className="footer flex-shrink-0 bg-white">
                <div className="container mx-auto py-16 px-5 lg:px-0">
                    <div className="grid lg:grid-cols-4 gap-8">

                        <div className="company-details">
                            <Link href="/">
                                <a className="h-12 lg:h-10 my-6 lg:my-0" title="Go to homepage">
                                    <Image
                                        src={process.env.NEXT_PUBLIC_LOGO_IMAGE}
                                        alt={config.company_name}
                                        width="200"
                                        height="40"
                                        className=""
                                        placeholder="blur"

                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                    />
                                </a>
                            </Link>

                            <p className="text-brand-tertiary text-sm my-3">{config.company_name}<br /> {config.address}<br /> {config.city}<br /> {config.pcode}</p>
                            <p className="text-brand-tertiary text-sm">Company No: {config.company_number}<br /> VAT Number: {config.vat_number}.</p>
                        </div>

                        <FooterMenu menu={get_footer_menu(menu)}></FooterMenu>

                        <div>
                            <h3 className="font-bold text-brand-tertiary text-xl mb-2">Get In Touch</h3>
                            <ul className="space-y-2 lg:mb-2 mb-4">
                                <li>
                                    <Link href="/contact">
                                        <a className="flex items-center group text-brand-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current text-brand-secondary mr-1 group-hover:mr-2 transition-all" width="6.414" height="10.829" viewBox="0 0 6.414 10.829">
                                                <path id="Chevron_Icon" data-name="Chevron Icon" d="M1180.983,1224l4,4,4-4" transform="translate(-1222.586 1190.397) rotate(-90)" fill="none" stroke="#0fa9a2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                            </svg>
                                            Contact Us
                                        </a>
                                    </Link>
                                </li>
                                <li className="flex items-center">
                                    <i className="text-gray-900 fas fa-phone-alt mr-1 fa-fw"></i>
                                    <Link href={"tel:" + config.phone}>
                                        <a className="text-brand-primary hover:underline flex items-center">
                                            {config.phone}
                                        </a>
                                    </Link>
                                </li>
                                <li className="flex items-center">
                                    <i className="text-gray-900 fab fa-whatsapp mr-1 fa-fw"></i>
                                    <Link href={"tel:" + config.whatsapp_phone}>
                                        <a className="text-brand-primary hover:underline">
                                            {config.whatsapp_phone}
                                        </a>
                                    </Link>
                                </li>
                                <li className="flex items-center">
                                    <i className="text-gray-900 fas fa-at mr-1 fa-fw"></i>
                                    <Link href={"mailto:" + config.email}>
                                        <a className="text-brand-primary hover:underline flex items-center">
                                            {config.email}
                                        </a>
                                    </Link>
                                </li>
                            </ul>
                            <Socialmedia config={config}></Socialmedia>
                        </div>

                    </div>
                    <div className="flex flex-wrap footer-icons gap-8 lg:gap-16 mt-10">
                        {(footericons && footericons.description) ? (
                            parse(footericons.description)
                        ) : ('')}
                    </div>

                </div>
                <div className="bg-brand-tertiary">
                    <div className="container mx-auto py-3 grid lg:grid-cols-2 gap-8 px-5 lg:px-0">

                        <p className="mb-0 text-gray-100 text-xs">&copy; {new Date().getFullYear()} {config.company_name}. <a href="https://www.adeogroup.co.uk/" rel="noreferrer" target="_blank" className="hover:text-white hover:underline">Website by Adeo</a></p>

                        <div className="legal-links text-gray-100 lg:text-right text-xs">
                            <BottomMenu menu={get_bottom_menu(menu)}></BottomMenu>
                        </div>

                    </div>
                </div>
            </footer>
            <Chat config={config}></Chat>
            <button
                className="hidden fixed bottom-6 right-16 py-3 px-4 leading-none text-white rounded z-40 bg-brand-secondary hover:bg-brand-primary active:bg-brand-tertiary focus:ring focus:ring-brand-secondary"
                aria-label="Back to Top"
                onClick={() => window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })}
            >
                <i className="text-white fas fa-angle-up align-baseline"></i>
            </button>
            {(cookies_popup ? 
            <>
            <div className="cookies-popup open-close">
                <div className="cookies-info-holder">
                    <strong className="title">We value your privacy</strong>
                    <div className="notice-group">
                        <div className="notice-des">
                            <p>We use cookies to enhance your browsing experience, serve personalised ads or content, and analyse our traffic. By clicking <strong>&quot;Accept All&quot;</strong>, you consent to our use of cookies.</p>
                        </div>
                        <div className={(cookies_custom_view ? 'notice-btn-wrapper active':'notice-btn-wrapper')}>
                            <button onClick={() => cookies_custom_active()} className="cky-btn cky-btn-customize opener cky-btn-customize-style" aria-label="Customize" data-cky-tag="settings-button">Customise</button>
                            <button onClick={() => cookies_reject_all()} className="cky-btn cky-btn-reject btn-hidee cky-btn-reject-style" aria-label="Reject All" data-cky-tag="reject-button" id="cookies-reject-all">Reject All</button>
                            <button onClick={() => cookies_accept_all()} className="cky-btn cky-btn-accept btn-hidee cky-btn-accept-style" aria-label="Accept All" data-cky-tag="accept-button" id="cookies-accept-all">Accept All</button>
                        </div>
                    </div>
                </div>
                <div className={(cookies_custom_view ? 'preference-holder':'preference-holder hidden')} id="animate">
                    <div className="preference">
                        <div className="preference-header">
                            <strong className="preference-title">Customise Consent Preferences</strong>
                        </div>
                        <div className="preference-body-wrapper">
                            <div className="preference-content-wrapper">
                                <p>We use cookies to help you navigate efficiently and perform certain functions. You will find detailed information about all cookies under each consent category below. The cookies that are categorised as &quot;Necessary&quot; are stored on your browser as they are essential for enabling the basic functionalities of the site. We also use third-party cookies that help us analyse how you use this website, store your preferences, and provide the content and advertisements that are relevant to you. These cookies will only be stored in your browser with your prior consent. You can choose to enable or disable some or all of these cookies but disabling some of them may affect your browsing experience.</p>
                            </div>
                            <div className="accordion-wrapper accordion-container" id="accordion">
                                <div className="cky-accordion content-entry">
                                    <div className="accordion-item article-title" onClick={() => set_show_secessary(!show_secessary)}>
                                        <div className="accordion-chevron">
                                        <svg className={(show_secessary ? 'hidden':'')} version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M9.707 18.707l6-6c0.391-0.391 0.391-1.024 0-1.414l-6-6c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0z"></path>
                                        </svg>
                                        <svg className={(show_secessary ? '':'hidden')} version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
                                        </svg>
                                        </div>
                                        <div className="accordion-header">
                                            <strong className="accordion-title">Necessary</strong>
                                            <span className="always-active" id="cookies-necessary">{cookies_necessary}</span>
                                        </div>
                                        <div className="accordion-header-des">
                                            <p>Necessary cookies are required to enable the basic features of this site, such as providing secure log-in or adjusting your consent preferences. These cookies do not store any personally identifiable data.</p>
                                        </div>
                                    </div>
                                    <div className={(show_secessary ? 'accordion-content':'accordion-content hidden')}>
                                        <div className="cky-audit-table cky-audit-table-style" data-cky-tag="audit-table">
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>_GRECAPTCHA</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>5 months 27 days</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>This cookie is set by the Google recaptcha service to identify bots to protect the website against malicious spam attacks.</div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>cookieyesID</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>1 year</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>CookieYes sets this cookie as a unique identifier for visitors according to their consent.</div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>cky-consent</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>1 year</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>
                                                        <p>The cookie is set by CookieYes to remember the users&apos; consent settings so that the website recognizes the users the next time they visit.</p>
                                                    </div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>cookieyes-necessary</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>1 year</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>CookieYes sets this cookie to remember the consent of users for the use of cookies in the &apos;Necessary&apos; category.</div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>cookieyes-functional</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>1 year</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>CookieYes sets this cookie to remember the consent of users for the use of cookies in the &apos;Functional&apos; category.</div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="cky-accordion content-entry padding-right">
                                    <div className="switch">
                                        <input type="checkbox" value={cookies_functional} onChange={() => set_cookies_functional(!cookies_functional)} id="cookies-functional" aria-label="Enable Functional" />
                                    </div>
                                    <div className="accordion-item article-title" onClick={() => set_show_content_functional(!show_content_functional)}>
                                        <div className="accordion-chevron">
                                        <svg className={(show_content_functional ? 'hidden':'')} version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M9.707 18.707l6-6c0.391-0.391 0.391-1.024 0-1.414l-6-6c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0z"></path>
                                        </svg>
                                        <svg className={(show_content_functional ? '':'hidden')} version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
                                        </svg>
                                        </div>
                                        <div className="accordion-header">
                                            <strong className="accordion-title">Functional</strong>
                                        </div>
                                        <div className="accordion-header-des">
                                            <p>Functional cookies help perform certain functionalities like sharing the content of the website on social media platforms, collecting feedbacks, and other third-party features.</p>
                                        </div>
                                    </div>
                                    <div className={(show_content_functional ? 'accordion-content':'accordion-content hidden')}>
                                        <div className="cky-audit-table cky-audit-table-style" data-cky-tag="audit-table">
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>intercom-id-aaxyypt0</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>8 months 26 days 1 hour</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div><p>This is an anonymous visitor identification cookie that is required to be able to talk to our customer support team via the live chat function.</p></div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>intercom-session-aaxyypt0</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>7 days</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div><p>This cookie is used to keep track of sessions for our live chat function.</p></div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>_hjAbsoluteSessionInProgress</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>30 minutes</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>Hotjar sets this cookie to detect a user&apos;s first pageview session, which is a True/False flag set by the cookie.</div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>_hjIncludedInPageviewSample</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>2 minutes</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>Hotjar sets this cookie to check whether a user is included in the data sampling defined by the site&apos;s pageview limit.</div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="cky-accordion content-entry padding-right">
                                    <div className="switch">
                                        <input type="checkbox" value={cookies_analytics} onChange={() => set_cookies_analytics(!cookies_analytics)} id="cookies-analytics" aria-label="Enable Functional" />
                                    </div>
                                    <div className="accordion-item article-title" onClick={() => set_show_content_analytics(!show_content_analytics)}>
                                        <div className="accordion-chevron">
                                        <svg className={(show_content_analytics ? 'hidden':'')} version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M9.707 18.707l6-6c0.391-0.391 0.391-1.024 0-1.414l-6-6c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0z"></path>
                                        </svg>
                                        <svg className={(show_content_analytics ? '':'hidden')} version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
                                        </svg>
                                        </div>
                                        <div className="accordion-header">
                                            <strong className="accordion-title">Analytics</strong>
                                        </div>
                                        <div className="accordion-header-des">
                                            <p>Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information on metrics such as the number of visitors, bounce rate, traffic source, etc.</p>
                                        </div>
                                    </div>
                                    <div className={(show_content_analytics ? 'accordion-content':'accordion-content hidden')}>
                                        <div className="cky-audit-table cky-audit-table-style" data-cky-tag="audit-table">
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>_ga</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>1 year 1 month 4 days</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>
                                                        <p>The _ga cookie, installed by Google Analytics, calculates visitor, session, campaign data, and also keeps track of site usage for the site&apos;s analytics report. The cookie stores information anonymously and assigns a randomly generated number to recognize unique visitors.</p>
                                                    </div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>_gid</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>1 day</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>
                                                        <p>Installed by Google Analytics, _gid cookie stores information on how visitors use a website, while also creating an analytics report of the website&apos;s performance. Some of the data that are collected include the number of visitors, their source, and the pages they visit anonymously.</p>
                                                    </div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>_gat</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>1 minute</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>
                                                        <p>This cookie is installed by Google Universal Analytics to restrain the request rate and thus limit the collection of data on high-traffic sites.</p>
                                                    </div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>_octo</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>1 year</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>
                                                        <p>This cookie is used by Octolytics, GitHub’s internal analytics service, to distinguish unique users and clients.</p>
                                                    </div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>logged_in</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>1 year</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>
                                                        <p>This cookie is used to signal to GitHub that the user is already logged in.</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="cky-accordion content-entry padding-right">
                                    <div className="switch">
                                        <input type="checkbox" value={cookies_advertise} onChange={() => set_cookies_advertise(!cookies_advertise)} id="cookies-advertise" aria-label="Enable Functional" />
                                    </div>
                                    <div className="accordion-item article-title" onClick={() => set_show_content_advertise(!show_content_advertise)}>
                                        <div className="accordion-chevron">
                                        <svg className={(show_content_advertise ? 'hidden':'')} version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M9.707 18.707l6-6c0.391-0.391 0.391-1.024 0-1.414l-6-6c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0z"></path>
                                        </svg>
                                        <svg className={(show_content_advertise ? '':'hidden')} version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
                                        </svg>
                                        </div>
                                        <div className="accordion-header">
                                            <strong className="accordion-title">Advertisement</strong>
                                        </div>
                                        <div className="accordion-header-des">
                                            <p>Advertisement cookies are used to provide visitors with customised advertisements based on the pages you visited previously and to analyse the effectiveness of the ad campaigns.</p>
                                        </div>
                                    </div>
                                    <div className={(show_content_advertise ? 'accordion-content':'accordion-content hidden')}>
                                        <div className="cky-audit-table cky-audit-table-style" data-cky-tag="audit-table">
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>_fbp</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>3 months</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>
                                                        <p>Facebook sets this cookie to display advertisements when the user is either on Facebook or on a digital platform powered by Facebook advertising, after visiting the website.</p>
                                                    </div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>__tld__</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>session</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>
                                                        <p>This cookie is used to track visitors on multiple websites in order to present relevant advertisement based on their preferences.</p>
                                                    </div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>fr</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>3 months</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>Facebook sets this cookie to show relevant advertisements to users by tracking user behaviour across the web, on sites that have Facebook pixel or Facebook social plugin.</div>
                                                </li>
                                            </ul>
                                            <ul className="cky-cookie-des-table">
                                                <li>
                                                    <div>Cookie</div>
                                                    <div>YSC</div>
                                                </li>
                                                <li>
                                                    <div>Duration</div>
                                                    <div>session</div>
                                                </li>
                                                <li>
                                                    <div>Description</div>
                                                    <div>YSC cookie is set by Youtube and is used to track the views of embedded videos on Youtube pages.</div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-wrapper">
                        <span className="footer-shadow"></span>
                        <div className="prefrence-btn-wrapper">
                            <button onClick={() => cookies_custom()} className="cky-btn cky-btn-preferences btn-hidee cky-btn-preferences-style" aria-label="Save My Preferences" data-cky-tag="detail-save-button" id="cookies-save-pref">Save My Preferences</button>
                        </div>
                    </div>
                </div>
            </div>
            </>
            : '')} 

        </>
    );
}

export default Footer;